module.exports = __webpack_public_path__ + "static/media/game_consoles3.899e8060.png";